export default "__VITE_ASSET__9b8ac41d__"